import { render, staticRenderFns } from "./PaperTicketPacking.vue?vue&type=template&id=732f065e&scoped=true&"
import script from "./PaperTicketPacking.vue?vue&type=script&lang=js&"
export * from "./PaperTicketPacking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732f065e",
  null
  
)

export default component.exports